export default __webpack_public_path__ + "static/media/tiktokDeskFill.48f436c1.svg";